import StyledLargeModal from './StyledLargeModal'

const LargeModal = props => (<StyledLargeModal {...props} />)

export default LargeModal
